<template>
    <div class="py-2 px-1.5">
        <label :for="spec.id+content.value" class="flex items-center cursor-pointer group">
            <span
                class="flex justify-center items-center rounded-full w-[40px] h-[40px] mr-1.5 outline-offset-2 outline-secondary duration-100 transition-all"
                :class="[is_selected(content.value) ? 'outline-[3px] outline' : 'group-hover:outline-[3px] group-hover:outline']">
                <i class="text-md" :class="'icon' in content ? content.icon : default_icon"></i>
            </span>
            <span>{{ content.name }}
            <span v-if="content.count" class="bg-secondary text-white rounded-full px-2 py-1">{{ content.count }}</span>
        </span>
        </label>
    </div>
</template>

<script>

export default {
    name: "icons",
    props: ['spec', 'content'],
    data: () => ({
        default_icon: 'fa-solid fa-ban',
    }),
    methods: {
        is_selected: function (val) {
            return new URL(window.location.href).searchParams.getAll(util.format('s%s[]', this.$props.spec.id)).filter(v => v === (val + '')).length > 0;
        }
    },
}
</script>

<style scoped>

</style>
